import Vue from 'vue';
import Vuex from 'vuex';
import contract from './modules/contract';
import studentData from './modules/studentData';
import documents from './modules/documents';
import enrollment from './modules/enrollment';
import payment from './modules/payment';
import pipeline from './modules/pipeline';
import RootState from './root_state';
import analytics from './modules/analytics';
import accountsUser from './modules/accounts';
import featureFlags from './modules/featureFlags';
import course from './modules/course';
import location from './modules/location';
import helperApp from './modules/helpers';
import prouni from './modules/prouni';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {} as RootState,
  mutations: {},
  actions: {},
  modules: {
    contract,
    studentData,
    documents,
    enrollment,
    payment,
    pipeline,
    analytics,
    accountsUser,
    featureFlags,
    course,
    location,
    helperApp,
    prouni,
  },
});
